(function(window, app, overwatch, $, _) {
    var mercyBCRFCharitySkin = {};

    var util = overwatch.util;

    mercyBCRFCharitySkin.trailerSetup = function trailerSetup() {
        $('[data-js="video-lightbox"]').on('click', function(event){
            var videoId = $(this).data('yt-id');
            if(!util.mobile() && !util.touch()){
                event.preventDefault();

                // play video in lightbox
                app.helpers.loadVideoIntoFrame(videoId);
            }
        });
    };

    mercyBCRFCharitySkin.init = function init() {
        this.trailerSetup();
    };

    app.extend({ mercyBCRFCharitySkin: mercyBCRFCharitySkin });

}(window, window.app, window.overwatch, window.jQuery, window._));
